export const extractButton = (buttons, term) => {
  const button = buttons.find(o => o.id === term);
  return button;
};
